<template>
  <div :class="{ wrapper_fill: fill }" class="wrapper">
    <b-overlay
      class="wrapper__overlay"
      :class="{ wrapper_loading: loading }"
      :show="loading"
    >
      <div class="wrapper__inner">
        <slot />
      </div>
    </b-overlay>
  </div>
</template>

<script>
export default {
  props: {
    loading: {
      type: Boolean,
      default: false,
    },

    fill: {
      type: Boolean,
      default: false,
    }
  },
};
</script>

<style lang="scss" scoped>
.wrapper {
  background: #fff;
  box-shadow: 0px 0px 13px 0px #ddd;
  border-radius: 10px;
  display: flex;
  flex-direction: column;


  &_fill {
    height: 100%;
  }

  &_loading {
    min-height: 150px;
  }

  &__inner {
    height: 100%;
  }

  &__overlay {
    padding: 15px;
    height: 100%;
  }
}
</style>
